// localStorage based progress tracking (no auth)
const STORAGE_KEY = "bk_progress_v1";

const readAll = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

const writeAll = (data) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

// Per category state:
// { learned: [factId], showLater: [factId], updatedAt: iso }
export const getCategoryProgress = (categoryId) => {
  const all = readAll();
  return all[categoryId] || { learned: [], showLater: [], updatedAt: null };
};

export const markLearned = (categoryId, factId) => {
  const all = readAll();
  const cur = all[categoryId] || { learned: [], showLater: [] };
  if (!cur.learned.includes(factId)) cur.learned.push(factId);
  cur.showLater = cur.showLater.filter((id) => id !== factId);
  cur.updatedAt = new Date().toISOString();
  all[categoryId] = cur;
  writeAll(all);
  return cur;
};

export const markShowLater = (categoryId, factId) => {
  const all = readAll();
  const cur = all[categoryId] || { learned: [], showLater: [] };
  if (!cur.showLater.includes(factId)) cur.showLater.push(factId);
  cur.updatedAt = new Date().toISOString();
  all[categoryId] = cur;
  writeAll(all);
  return cur;
};

export const unmarkLearned = (categoryId, factId) => {
  const all = readAll();
  const cur = all[categoryId] || { learned: [], showLater: [] };
  cur.learned = cur.learned.filter((id) => id !== factId);
  cur.updatedAt = new Date().toISOString();
  all[categoryId] = cur;
  writeAll(all);
  return cur;
};

export const resetCategoryProgress = (categoryId) => {
  const all = readAll();
  delete all[categoryId];
  writeAll(all);
};

export const resetAllProgress = () => {
  writeAll({});
};
